module.exports = __webpack_public_path__ + "img/finish_icon_aedecp.ef850af5.svg";